import React, { useEffect, useRef, useState } from "react";

const Dropdown = ({ placeholder, options, onOptionSelect = () => { }, labelKey = "title", onOpenChange, isOpen: controlledIsOpen }) => {

    const [internalIsOpen, setInternalIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Use controlled state if provided, otherwise use internal state
    const isOpen = controlledIsOpen !== undefined ? controlledIsOpen : internalIsOpen;

    const handleToggle = (event) => {
        if (event) {
            event.stopPropagation();
        }
        const newIsOpen = !isOpen;
        if (controlledIsOpen === undefined) {
            setInternalIsOpen(newIsOpen);
        }
        // Notify parent of state change
        if (onOpenChange) {
            onOpenChange(newIsOpen);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                const clickedCard = event.target.closest('.vehicle-style-item');
                const dropdownCard = dropdownRef.current.closest('.vehicle-style-item');

                if (clickedCard && dropdownCard && clickedCard === dropdownCard) {
                    return;
                }

                if (controlledIsOpen === undefined) {
                    setInternalIsOpen(false);
                }
                // Notify parent of state change
                if (onOpenChange) {
                    onOpenChange(false);
                }
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen, controlledIsOpen, onOpenChange]);

    const onSelect = (option) => {
        onOptionSelect(option);
    };

    return (
        <div className={`custom-dropdown ${isOpen ? "open" : ""}`} ref={dropdownRef}>
            <div className="dropdown__toggler" onClick={handleToggle}>
                <button type="button" className="dropdown__toggler-button">
                    <span className="dropdown__toggler-button-text">
                        {placeholder || "Select an option"}
                    </span>
                </button>
                <svg className={`dropdown__toggler-arrow ${isOpen ? "open" : ""}`} width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.8" d="M0.699219 0.699219L6.73818 5.69922L12.7771 0.699219" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>
            <div className={`dropdown__options ${isOpen ? "open" : ""}`}>
                {options.map((option) => (
                    <div onClick={() => onSelect(option)} key={option._key} className="dropdown__option">
                        {option?.[labelKey]}
                        <svg width="6" height="14" viewBox="0 0 6 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.749999 0.75L4.75 6.75L0.75 12.75" stroke="#00344E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                    </div>
                ))}
            </div>
        </div>
    );
};

export default Dropdown;